import { useEffect } from "react";
import FindAccount from "../components/login/FindAccount";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet-async";

function FindAccountScreen() {
    const [cookies] = useCookies(["KMNM", "KMUI"]);

    useEffect(() => {
        const iamport = document.createElement("script");
        const jquery = document.createElement("script");
        iamport.src = "https://cdn.iamport.kr/js/iamport.payment-1.1.7.js";
        jquery.src = "https://code.jquery.com/jquery-1.12.4.min.js";
        document.head.appendChild(iamport);
        document.head.appendChild(jquery);
        return () => {
            document.head.removeChild(iamport);
            document.head.removeChild(jquery);
        };
    }, []);

    const onClickRegist = () => {
        // const data: PaymentData = {
        //     name: cookies.KMNM,
        //     email: cookies.KMUI,
        // };
        // Upgrade(data);
    };
    return (
        <>
            <Helmet>
                <title>계정 찾기 - 모두의지도</title>
                <meta name="description" content="이메일 또는 비밀번호를 찾으세요" />
            </Helmet>
            <div>
                <FindAccount />
            </div>
        </>
    );
}

export default FindAccountScreen;
